module.exports = __webpack_public_path__ + "static/media/NMATP.a7bf6ed4.png";